import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import { Footer } from './Footer';
import { Header } from './Header';

const defaultRender = () => null;

type PageProps = {
  render: () => React.ReactElement | null;
};

export const Page = ({ render = defaultRender }: PageProps) => {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <Container
        component="main"
        maxWidth="xl"
        sx={{ flex: 1, py: { xs: 3, md: 4 } }}
      >
        {render()}
      </Container>
      <Footer />
    </Box>
  );
};
